export default "__VITE_ASSET__MyF6CTs8__"